import React from 'react';
import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import { TypographyProps } from '@material-ui/core/Typography';
import Small from './Small';

type TermProps = Omit<TypographyProps, 'color'> & {
  active?: boolean;
  fixed?: boolean;
};

const styles = (theme): StyleRules => ({
  root: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    height: (props: TermProps) =>
      props.fixed
        ? `calc(${theme.typography.pxToRem(12)} * ${
            theme.typography.body1.lineHeight
          } * 2)`
        : undefined,
    fontSize: theme.typography.pxToRem(12),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(14),
      height: (props: TermProps) =>
        props.fixed
          ? `calc(${theme.typography.pxToRem(14)} * ${
              theme.typography.body1.lineHeight
            } * 2)`
          : undefined,
    },
  },
});

const Term = ({ active, fixed, ...props }: TermProps) => (
  <Small {...props} color={active ? 'textPrimary' : 'textSecondary'} />
);

export default withStyles(styles)(Term);
